import React from 'react';
import { Typography } from '@material-ui/core';
import { faqUrl, termsOfUseUrl } from '../../../../utils';
import UrlLink from '@material-ui/core/Link';

const reviewedStartMessage: string =
  'Our team has reviewed the submitted Lines and has decided not to offer';

export const resubmitApp: string =
  'If you believe we made a mistake, please resubmit and include any supporting information that can help our team make a decision.';

export const mistake: string =
  'This may be due to a mistake during data-entry, so we have returned your Lines to ‘Draft’ to give you an opportunity to edit the unit quantities, costs and dates, and resubmit.';

export const header: string = 'Attn: Please amend + resubmit your application';

export const ourTeamReviewed = (salesOrSeller: string, storeName: string) => {
  return (
    <>
      <Typography>
        {reviewedStartMessage} {storeName} a Growth Plan at this time, since the
        product you are attempting to finance does not meet our {salesOrSeller}{' '}
        history requirements. For more information, please review our{' '}
        <UrlLink href={faqUrl} target="_blank">
          FAQs
        </UrlLink>{' '}
        and our{' '}
        <UrlLink href={termsOfUseUrl} target="_blank">
          Terms of Use
        </UrlLink>
        .
      </Typography>
    </>
  );
};

export const incompleteData = (storeName: string) => {
  return (
    <>
      <Typography gutterBottom>
        Our team has decided not to offer {storeName} a Growth Plan at this
        time, since we do not have sufficient data to thoroughly assess this
        application.
      </Typography>
      <Typography>
        <b>What happens next?</b>
      </Typography>
      <Typography>
        We encourage you to verify that your store and bank account are
        correctly connected, before attempting to resubmit your Lines.
      </Typography>
      <Typography>
        If you believe we made a mistake, please resubmit your Lines, and
        include any supporting information that can help our team make a
        decision.
      </Typography>
      <Typography>
        To read more about the data we collect and how we make decisions, please
        see our
        <UrlLink href={faqUrl} target="_blank">
          FAQs
        </UrlLink>
        .
      </Typography>
    </>
  );
};

export const whatHappenNext = (companyName) => (
  <>
    <Typography>
      <b>What happens next? </b>
    </Typography>
    <Typography>
      We encourage you to apply again in the future should you meet our
      requirements.
    </Typography>
    <Typography>
      If you believe we made a mistake, please re-submit your Lines and include
      any supporting information that can help our team make a decision.
    </Typography>
    <Typography>
      Meanwhile, you are welcome to continue using {companyName}’s suite of
      planning tools free of charge.
    </Typography>
  </>
);
